var OperativeSystem;
(function (OperativeSystem) {
    OperativeSystem["WINDOWS"] = "Windows";
    OperativeSystem["MACOS"] = "macOS";
})(OperativeSystem || (OperativeSystem = {}));
export { OperativeSystem };
//# sourceMappingURL=DownloadButton.types.js.map